import { faUser, IconName, fas } from '@fortawesome/pro-solid-svg-icons';
import * as React from 'react';
import { Applications } from './Applications';
import { library } from '@fortawesome/fontawesome-svg-core';
import { Header } from './Header';
import { HeaderContainer } from './HeaderContainer';
import { oidcService as oidc, authService } from './Appstartup';
import { Col, Row } from 'jsxstyle';
import { GenericError } from './GenericError';

library.add(fas);

interface AppProps {
    path: string;
}

class App extends React.Component<AppProps, any> {
    constructor(props: AppProps) {
        super(props);
        this.state = {
            user: null,
            applications: [],
            error: '',
            path: props.path
        };
    }
    async componentDidMount() {
        if (this.state.path === '/callback') {
            oidc.loginCallback().then(
                () => {
                    window.history.replaceState(
                        {},
                        window.document.title,
                        window.location.origin
                    );
                    this.setState({ path: '/' }, this.login);
                },
                function(error) {
                    console.error(error);
                }
            );
        } else {
            this.login();
        }
    }

    login = async () => {
        let user = await oidc.getUser();
        if (user) {
            if (user.expired) {
                let renewed = await oidc.renewToken();
                authService.setToken(renewed.access_token);
            } else {
                authService.setToken(user.access_token);
            }
            this.setState({ user: user }, this.fetchApplications);
        } else {
            oidc.login();
        }
    };

    fetchApplications = async () => {
        try {
            let apps = await authService.getApplications();
            this.setState({ applications: apps.data });
        } catch {
            this.setState({
                error:
                    'Sorry, an error occurred, if the problem persists please contact support'
            });
        }
    };

    private renderContent() {
        let { applications, error } = this.state;
        if (error)
            return (
                <Row justifyContent="center" alignItems="center">
                    <GenericError />
                </Row>
            );
        if (this.state.path === '/callback') {
            return <h2>Login in progress, please wait</h2>;
        }
        return <Applications applications={applications} mode="large" />;
    }
    public render() {
        let { applications } = this.state;
        return (
            <Col height="100%">
                <HeaderContainer
                    user={this.state.user}
                    applications={applications}
                    appName="APPS"
                />
                <Row flex={1} alignItems="center" justifyContent="center">
                    {this.renderContent()}
                </Row>
            </Col>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx